<template>
  <div id="userLogin">
    <div>
      <h2>
        <!-- <svg class="icon" aria-hidden="true">
          <use xlink:href="#se-icon-elephant"></use>
        </svg> -->
        <span>设备管理链接</span>
      </h2>
      <form>
        <div>
          <keep-alive>
            <se-autocomplete v-model="iccid" :fetchsuggestions="querySearch" @select="handleSelect"
              placeholder="请输入设备号"></se-autocomplete>
          </keep-alive>
        </div>
        <div class="formLine">
          <mt-button type="primary" style="background:#0066FF" size="large" @click.prevent="userQuerySIM">设备管理</mt-button>
        </div>
      </form>
    </div>

    <p style="text-align: center;font-size: 10px;margin-top:1rem;color:red">提醒：设备设置完成后 重启设备或等待5分钟即可。</p>
    <!-- <img
      style="width: 100%; margin-top: 1rem;"
      src="@/assets/advertising3.jpg"
      alt=""
      @click="goto('http://szyanyun.com/download.html')"
    /> -->
    <!-- <button class="download" @click="goto('http://szyanyun.com/download.html')" >点击下载</button> -->

    <!-- <Advertisement></Advertisement> -->
  </div>
</template>

<script>
import { Dialog } from "vant";
import { Toast } from "vant";
import { wxRequest } from "@/api/user.js";
import SeAutocomplete from "@/components/SeAutocomplete";
import Advertisement from "@/components/Advertisement";
export default {
  components: { SeAutocomplete, Advertisement },
  data() {
    return {
      iccid: "",
      code: "",
      showAds: true,
      gzh: "",
      homeTitle: '',
      realNameList: [
        "1192351241053663232",
        "1224969664338063360",
        "1255666672321163264",
        "7DA692EC992B45E297450F40DEDC5614",
        "8601954A2B074E80AACAAF32C5EE232C",
        "960F3276EFAA4ED2999754895F4BCCB4",
        "B1E112B9F1D8420E9072D9F47D6A135E",
        "1275705014286807040",
        "1275706083402313728",
        "1274979554988912640",
        "1279289937396494336",
      ],
      suolangList: ["1275704520822747136"],
    };
  },
  methods: {
    querySearch(queryString, cb) {
      var listAll = this.getAutoCompleteData("iccidList");
      var results = queryString
        ? listAll.filter(this.createFilter(queryString))
        : listAll;
      cb(results);
    },
    createFilter(queryString) {
      return (listAll) => {
        return listAll.indexOf(queryString) == 0;
      };
    },
    handleSelect(item) {
      this.iccid = item;
    },
    userQuerySIM() {
      if (!this.iccid || this.iccid.length < 3) {
        Dialog.alert({ title: "提示", message: "请输入正确卡号" });
        return false;
      }

      let recordLoginText = this.iccid; //存放用户登录时输入的文本，将用于首页显示

      let data = {
        requestId: this.iccid,
        code: "1",
      };
      wxRequest("sim/bind", data, "get").then((res) => {
        if (res.data.code == 200) {
          let record = res.data.data;
          let iccid = record.iccid;

          if (record.titleMap) {
            localStorage.setItem("wxTitle", record.titleMap.title);
            localStorage.setItem("wxText", record.titleMap.context);
            localStorage.setItem("wxUrls", record.titleMap.urls);
          } else {
            localStorage.setItem("wxTitle", '');
            localStorage.setItem("wxText", '');
            localStorage.setItem("wxUrls", '');
          }
          localStorage.setItem('isNewPage', record.isNewPage);
          this.$store.state.isNewPage = record.isNewPage;
          localStorage.setItem('newHomeImg', record.newHomeImg);
          localStorage.setItem('newHomeUrl', record.newHomeUrl);



          localStorage.setItem("mobile", record.mobile);
          localStorage.setItem("supplierTypeName", record.supplierTypeName);
          localStorage.setItem("wxHeadImg", record.wxHeadImg);
          localStorage.setItem("wxNickName", record.wxNickName);
          localStorage.setItem("recordLoginText", recordLoginText);
          localStorage.setItem("supplierName", record.supplierName);
          localStorage.setItem("iccid", iccid);
          localStorage.setItem("intoNo", record.intoNo);
          localStorage.setItem("phoneNo", record.userPhone);
          localStorage.setItem("userPhone", record.userPhone);


          localStorage.setItem("openId", record.openId);
          localStorage.setItem("agentId", record.agentId);
          localStorage.setItem("flowRatePool", record.flowRatePool);
          window.location.href='http://oopen.sunshineiot.net/oopen/index.html#/pages/index/indexBox?iccid='+record.virtualNo;
        } else {
          Dialog.alert({ title: "提示", message: res.data.message });
        }
      });
    },

    //获取url参数
    getQueryVariable(variable) {
      var query = window.location.search.substring(1);
      var vars = query.split("&");
      for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        if (pair[0] == variable) {
          return pair[1];
        }
      }
      return false;
    },

    goBuyCard() {
      window.location.href = "http://wx.wzyw.cc/#/user/login2";
    },

    // goto(path){
    //     //广告点击统计
    //     wxRequest("link/click",{url: path}, "get").then(res => {
    //         window.location.href = path;
    //     });

    // },
  },
  async created() {
    var source = this.getQueryVariable("source") ? this.getQueryVariable("source") : process.env.VUE_APP_APPID;
    this.dialogIccid = ''
    var appid = source ? source : process.env.VUE_APP_APPID;
    await wxRequest("/sim/get/appId", {}, "get").then((res) => {
      if (res.data.code == 200) {
        appid = res.data.data;
      }
    });
    localStorage.setItem("appid", source);
    localStorage.setItem("isHeadquarterAppid", false);


    localStorage.setItem("leshuaPay", 1);
    this.code = "leshua";
    this.iccid = localStorage.getItem("recordLoginText");

    this.$store.commit("setIsHeadquarterAppid", "true");
    localStorage.setItem("isHeadquarterAppid", true);
  },

  mounted() { },

  beforeDestory() { },
};
</script>

<style lang="less">
#verified {
  height: 100%;

  h4 {
    color: #fff;
    font-size: 10px;
    background: #26a2ff;
    line-height: 1.5em;
    padding: 6px 3%;
  }

  ul {
    margin: 10px;

    li {
      line-height: 36px;
      padding: 3px 0;
      border-bottom: 1px solid #ffa33a;

      svg {
        vertical-align: middle;
        margin-right: 8px;
      }

      .codeBtn {
        float: right;
        margin-top: 2px;
      }
    }
  }

  .main {
    height: calc(100% - 48px);
    padding: 0 4%;

    form {
      height: 100%;
    }

    .line {
      border-bottom: 1px solid #e5e5e5;
    }

    // .many {
    //     display: flex;
    //     justify-content: space-between;
    //     label {
    //         display: block;
    //         line-height: 36px;
    //     }
    //     .uploadOuter {
    //         position: relative;
    //         display: flex;
    //         justify-content: center;
    //         align-items: center;
    //         width: 48%;
    //         height: 100px;
    //         border: 1px dashed #e5e5e5;
    //         box-sizing: border-box;
    //         input[type=file] {
    //             position: absolute;
    //             top: 0;
    //             width: 0;
    //             width: 100%;
    //             height: 100%;
    //             opacity: 0;
    //         }
    //         img {
    //             width: 100%;
    //             height: 100%;
    //         }
    //     }
    // }
    // .title {
    //     line-height: 28px;
    //     margin-top: 10px;
    // }
    .btnOuter {
      // display: flex;
      // align-items: center;
      // height: calc(100% - 424px;)
      background: #26a2ff;

      margin-top: 30px;
    }
  }

  .card-dianxin {
    width: 100%;
    height: 100%;

    h1 {
      font-size: 14px;
      background: #fff;
      line-height: 1.5em;
      padding: 6px 3%;
    }

    .dianxin-iframe {
      width: 100%;
      height: 100%;
    }
  }

  .card-other {
    width: 100%;
    height: 100%;
  }

  input.van-field__control {
    padding-left: 5px;
    line-height: 24px;
  }
}
</style>
